define([
    'react',
    'lodash',
    'table/table-pager/table-pager/table-pager',
    'table/table-sizer/table-sizer'
], function (React, _, TablePager, TableSizer) {
    'use strict';
    return function () {
        return React.createElement('div', {}, React.createElement('div', { 'className': this.getTableClass() }, this.getChildren()), React.createElement('div', { 'className': this.getActionsClass() }, this.props.pager ? React.createElement(TablePager, {
            'model': this.props.model,
            'totalPageCount': this.props.totalPageCount,
            'onPagerChange': this.props.onPagerChange
        }) : null, this.props.sizer ? React.createElement(TableSizer, {
            'model': this.props.model,
            'totalItems': this.props.totalItems,
            'onSizerChange': this.props.onSizerChange
        }) : null));
    };
});


/*****************
 ** WEBPACK FOOTER
 ** ./src/table/table-container/table-container.rt
 ** module id = 192
 ** module chunks = 0
 **/